const ArticleSearchNoMatch = ({ inputResult }) => (
  <div className="section__no-matches">
    <div className="title section__no-matches-title _mb-8">
      No results for "{inputResult}"
    </div>
    <div className="text section__no-matches-text">
      Check the spelling or try modifying your search.
    </div>
  </div>
);

export default ArticleSearchNoMatch;
